import { FC } from 'react';
import { AllieFlagOutlineIcon } from '../../styling/icons';
import { AlliePriorityFlagProps } from './Flag.types';
import './Flag.css';

export const AlliePriorityFlag: FC<AlliePriorityFlagProps> = ({ priority }) => (
  <div className={`allie-priority-flag allie-priority-flag-${priority}`}>
    <AllieFlagOutlineIcon />
  </div>   
);
